// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FaqPage_faqPage__2CNY6 {
  color: var(--color-text);
  margin-top: calc(var(--space-lg) + 100px);
}

.FaqPage_header__LP7HK {
  text-align: center;
  margin-bottom: var(--space-xl);
}

.FaqPage_eyebrow__JUWdF {
  color: var(--color-text-subtle);
  font-size: var(--font-size-small);
  margin-bottom: var(--space-sm);
}

.FaqPage_title__Cd8Li {
  font-size: 3rem;
  font-weight: 400;
  margin-bottom: var(--space-sm);
  text-wrap: balance;
}

.FaqPage_intro__fYkhY {
  max-width: 42rem;
  margin: 0 auto;
  font-size: var(--font-size-medium);
  color: rgba(255, 255, 255, 0.8);
}

.FaqPage_sections__b3k69 {
  display: grid;
  gap: var(--space-xl);
  padding: 0 8rem var(--space-xxl);
}

.FaqPage_section__llRus {
  display: grid;
  gap: var(--space-md);
}

.FaqPage_sectionTitle__pbAHl {
  font-size: var(--font-size-large);
  font-weight: 400;
}

.FaqPage_accordionList__R8\\+OE {
  display: grid;
  gap: 0.85rem;
}

.FaqPage_accordionItem__44lIo {
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.02);
  overflow: hidden;
  scroll-margin-top: 9rem;
}

.FaqPage_accordionItem__44lIo.FaqPage_open__YAliJ {
  border-color: rgba(77, 163, 255, 0.45);
}

.FaqPage_question__N52ZL {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-md);
  padding: 1.15rem 1.25rem;
  background: transparent;
  border: none;
  color: var(--color-text);
  font-size: var(--font-size-base);
  text-align: left;
  cursor: pointer;
}

.FaqPage_symbol__B28Ri {
  flex: 0 0 auto;
  color: #4da3ff;
  font-size: 1.4rem;
  line-height: 1;
}

.FaqPage_answerWrap__ZPWJq {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.28s ease;
}

.FaqPage_accordionItem__44lIo.FaqPage_open__YAliJ .FaqPage_answerWrap__ZPWJq {
  grid-template-rows: 1fr;
}

.FaqPage_answer__WI-cM {
  overflow: hidden;
}

.FaqPage_answer__WI-cM p {
  padding: 0 1.25rem 1.25rem;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.65;
}

@media (max-width: 768px) {
  .FaqPage_title__Cd8Li {
    font-size: var(--font-size-xxlarge);
  }

  .FaqPage_intro__fYkhY {
    font-size: var(--font-size-base);
    padding: 0 var(--space-md);
  }

  .FaqPage_sections__b3k69 {
    padding: 0 14px var(--space-xxl);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FaqPage.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;EACpB,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,gCAAgC;IAChC,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;AACF","sourcesContent":[".faqPage {\n  color: var(--color-text);\n  margin-top: calc(var(--space-lg) + 100px);\n}\n\n.header {\n  text-align: center;\n  margin-bottom: var(--space-xl);\n}\n\n.eyebrow {\n  color: var(--color-text-subtle);\n  font-size: var(--font-size-small);\n  margin-bottom: var(--space-sm);\n}\n\n.title {\n  font-size: 3rem;\n  font-weight: 400;\n  margin-bottom: var(--space-sm);\n  text-wrap: balance;\n}\n\n.intro {\n  max-width: 42rem;\n  margin: 0 auto;\n  font-size: var(--font-size-medium);\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.sections {\n  display: grid;\n  gap: var(--space-xl);\n  padding: 0 8rem var(--space-xxl);\n}\n\n.section {\n  display: grid;\n  gap: var(--space-md);\n}\n\n.sectionTitle {\n  font-size: var(--font-size-large);\n  font-weight: 400;\n}\n\n.accordionList {\n  display: grid;\n  gap: 0.85rem;\n}\n\n.accordionItem {\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 1rem;\n  background: rgba(255, 255, 255, 0.02);\n  overflow: hidden;\n  scroll-margin-top: 9rem;\n}\n\n.accordionItem.open {\n  border-color: rgba(77, 163, 255, 0.45);\n}\n\n.question {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--space-md);\n  padding: 1.15rem 1.25rem;\n  background: transparent;\n  border: none;\n  color: var(--color-text);\n  font-size: var(--font-size-base);\n  text-align: left;\n  cursor: pointer;\n}\n\n.symbol {\n  flex: 0 0 auto;\n  color: #4da3ff;\n  font-size: 1.4rem;\n  line-height: 1;\n}\n\n.answerWrap {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.28s ease;\n}\n\n.accordionItem.open .answerWrap {\n  grid-template-rows: 1fr;\n}\n\n.answer {\n  overflow: hidden;\n}\n\n.answer p {\n  padding: 0 1.25rem 1.25rem;\n  color: rgba(255, 255, 255, 0.78);\n  line-height: 1.65;\n}\n\n@media (max-width: 768px) {\n  .title {\n    font-size: var(--font-size-xxlarge);\n  }\n\n  .intro {\n    font-size: var(--font-size-base);\n    padding: 0 var(--space-md);\n  }\n\n  .sections {\n    padding: 0 14px var(--space-xxl);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faqPage": `FaqPage_faqPage__2CNY6`,
	"header": `FaqPage_header__LP7HK`,
	"eyebrow": `FaqPage_eyebrow__JUWdF`,
	"title": `FaqPage_title__Cd8Li`,
	"intro": `FaqPage_intro__fYkhY`,
	"sections": `FaqPage_sections__b3k69`,
	"section": `FaqPage_section__llRus`,
	"sectionTitle": `FaqPage_sectionTitle__pbAHl`,
	"accordionList": `FaqPage_accordionList__R8+OE`,
	"accordionItem": `FaqPage_accordionItem__44lIo`,
	"open": `FaqPage_open__YAliJ`,
	"question": `FaqPage_question__N52ZL`,
	"symbol": `FaqPage_symbol__B28Ri`,
	"answerWrap": `FaqPage_answerWrap__ZPWJq`,
	"answer": `FaqPage_answer__WI-cM`
};
export default ___CSS_LOADER_EXPORT___;
